import { deleteRol, getRolesLista } from "../../services/RolesServices";
import { RolesContext } from "./RolesContext"

export const RolesState = ({ children }) => {
    const getRolesListaData = async () => {
        let res = await getRolesLista()
        return res;
    }

    const deleteRolData = async (body) => {
        const res = await deleteRol(body)
        if (res) getRolesListaData()
        return res
    }

    return <RolesContext.Provider value={{
        getRolesListaData,
        deleteRolData,
    }} >
        {children}
    </RolesContext.Provider>
}